import { restrictedAccess } from '../middleware'

export default {
  path: 'downtime-reports',
  component: () => import('@/views/admin/downtime-reports/Page.vue'),
  beforeEnter: restrictedAccess(1),
  children: [
    {
      name: 'DowntimeReports.Index',
      path: '',
      component: () => import('@/views/admin/downtime-reports/Index.vue'),
    },
    {
      name: 'DowntimeReports.Create',
      path: 'create',
      component: () => import('@/views/admin/downtime-reports/v2/Create.vue'),
    },
    {
      name: 'DowntimeReports.Edit',
      path: ':downtimeReportId/edit',
      component: () => import('@/views/admin/downtime-reports/v2/Edit.vue'),
    },
    {
      name: 'DowntimeReports.Show',
      path: ':downtimeReportId/show',
      component: () => import('@/views/admin/downtime-reports/Show.vue'),
    },
  ],
}